import { IFCWithChildren } from '~/common/interfaces/i-fc-with-childrent';

import { Body, MainLayoutContainer, StyBodyWrapper } from './styles';
import { Header } from './header';

export const PrivateLayout: IFCWithChildren = ({ children }) => (
  <MainLayoutContainer>
    <Header />
    <StyBodyWrapper id="mainlayoutcontainer">
      <Body>{children}</Body>
    </StyBodyWrapper>
  </MainLayoutContainer>
);
